import { Box, Stack } from '@mui/material';

import { GroupLabel } from '@/cam-admin/control-panel/bits';
import NotificationStack from '@/cam-admin/notifications/NotificationStack';
import {
  type CamNotification,
  type NotificationGroup,
} from '@/cam-admin/notifications/Notifications.fixtures';

// The recency chunks of the feed, newest first. Each chunk that has items
// renders its label (TODAY / THIS WEEK / EARLIER) and a NotificationStack of
// its rows; empty chunks are skipped.
const SECTIONS: { id: NotificationGroup; label: string }[] = [
  { id: 'today', label: 'TODAY' },
  { id: 'week', label: 'THIS WEEK' },
  { id: 'earlier', label: 'EARLIER' },
];

// The notifications feed: customer activity grouped into recency chunks. Reads
// the visible (already filtered) items and lays them out chunk by chunk.
const NotificationsList = ({
  items,
  onOpen,
  onToggleRead,
}: {
  items: CamNotification[];
  onOpen: (n: CamNotification) => void;
  onToggleRead: (n: CamNotification) => void;
}) => (
  <Stack spacing={2}>
    {SECTIONS.map((section) => {
      const group = items.filter((n) => n.group === section.id);
      if (group.length === 0) return null;
      return (
        <Box key={section.id}>
          <Box sx={{ mb: 1 }}>
            <GroupLabel>{section.label}</GroupLabel>
          </Box>
          <NotificationStack
            items={group}
            onOpen={onOpen}
            onToggleRead={onToggleRead}
          />
        </Box>
      );
    })}
  </Stack>
);

export default NotificationsList;
